import { render, staticRenderFns } from "./AppSelector.vue?vue&type=template&id=58a3460c"
import script from "./AppSelector.vue?vue&type=script&lang=js"
export * from "./AppSelector.vue?vue&type=script&lang=js"
import style0 from "./AppSelector.vue?vue&type=style&index=0&id=58a3460c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports